import {
  parseActivities,
  parseActivity,
  parseActivityCategories,
  parseActivityCategoriesWithDefaultDates,
  parseActivityDefaultDates
} from 'activities/activitiesParser';
import {
  setActivities,
  setActivityCategories,
  setActivityDefaultDates
} from 'activities';
import { getActivityCategories } from 'activities/selectors';

export const processActivity = ({ rawActivity }) => {
  const activityUuid = parseActivity(rawActivity);
  if (activityUuid) {
    return Promise.resolve(activityUuid);
  }
  return Promise.reject('activity response was empty');
};

export const processActivities = ({ dispatch, rawActivities }) => {
  const activities = parseActivities(rawActivities);
  if (activities) {
    dispatch(setActivities({ activities }));
    return Promise.resolve(activities);
  }
  return Promise.reject('activity response was empty');
};

export const processActivityCategories = ({ dispatch, rawCategories }) => {
  const categories = parseActivityCategories(rawCategories);
  dispatch(setActivityCategories({ categories }));
  if(categories) {
    return Promise.resolve(categories);
  }
  return Promise.reject('categories response was empty');
};

export const processActivityDefaultDates = ({ dispatch, getState, productYears }) => {
  const activityDefaultDates = parseActivityDefaultDates(productYears);
  dispatch(setActivityDefaultDates(activityDefaultDates));

  const state = getState();
  const categories = getActivityCategories(state);
  const categoriesWithDefaultDates = parseActivityCategoriesWithDefaultDates({ categories, activityDefaultDates });
  dispatch(setActivityCategories({ categories: categoriesWithDefaultDates }));

  return Promise.resolve(activityDefaultDates);
};
